import { useCallback, useEffect, useRef, useState } from 'react'

export const useBreakpoint = (
  breakpoint: number,
  elementRef: React.RefObject<HTMLElement>,
): boolean => {
  const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(false)
  const observerRef = useRef<ResizeObserver | null>(null)

  const handleResize = useCallback(
    (entries: ResizeObserverEntry[]) => {
      const [entry] = entries
      if (entry) {
        setIsBelowBreakpoint(entry.contentRect.width <= breakpoint)
      }
    },
    [breakpoint],
  )

  useEffect(() => {
    if (!elementRef.current) return

    observerRef.current = new ResizeObserver(handleResize)
    observerRef.current.observe(elementRef.current)

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
    }
  }, [handleResize, elementRef])

  return isBelowBreakpoint
}
